
import { Component, Vue, Watch } from 'vue-property-decorator';
import ImagesUpload from '@/components/ImagesUploadMarketing/images-upload.vue';
import Recharge from '@/components/Recharge/index.vue';
import { adAddEdit, getAdList } from '@/api/exchange-code';
import { PublicQuery } from '@/mixins/public_query';
import { iImagesList, iAdparams, eInputType, iExtend, eOpenState } from '@/interface/exchange-code';
import { eOptionType } from '@/interface/eCommand';
@Component({
  components: { ImagesUpload, Recharge },
})
export default class AdsenseNotice extends Vue {
  publicQuery = new PublicQuery();
  openTypeList: any = [
    {
      label: '跳转链接',
      value: 'link',
    },
    {
      label: '打开游戏',
      value: 'game',
    },
  ];
  gameList: any = [];
  extend: any = {
    game_id: -1,
  };
  rechargeModel: any = {
    state: true,
    desc: '',
    popupState: true,
    imageUrl: '',
    grade_type: -1,
    grade_id: -1,
  };
  rechargeDesc: any = {
    width: 316,
    height: 482,
    maxLen: 32,
  };
  imagesList: iImagesList[] = [];
  textImage: iImagesList[] = [];
  paramsImages: iAdparams = {
    app_id: 'cloudPC_client',
    advs: [
      {
        idx: '',
        idx_name: '',
        pos: '',
        pos_name: '',
        img: '',
        main_title: '',
        sub_title: '',
        link: '',
        extend: '',
        op_type: '',
      },
    ],
  };
  loading: boolean = false;
  /* 验证 */
  rules() {
    let falg = true;
    this.paramsImages.advs = [];
    let selectValue: number = -1;
    for (let item of this.imagesList) {
      selectValue = parseInt(item.fillText![3].value);
      if (!item.imageUrl) {
        this.$message.error('图片位--' + item.position + '位置图片未上传');
        falg = false;
        return falg;
      } else if (!item.fillText![0].value) {
        this.$message.error('图片位--' + item.position + '位置标题未填写');
        falg = false;
        return falg;
      } else if (item.fillText![1].value == eOptionType.GAME) {
        if (selectValue <= 0) {
          this.$message.error('图片位--' + item.position + '游戏类型未选择');
          falg = false;
          return falg;
        }
      }
      this.paramsImages.advs.push({
        idx: 'idx_img',
        idx_name: '图片位',
        pos: item.positionValue,
        pos_name: item.position,
        img: item.imageUrl,
        main_title: item.fillText![0].value,
        link: item.fillText![2].value,
        op_type: item.fillText![1].value /* 类型 */,
        extend:
          item.fillText![1].value == 'game'
            ? JSON.stringify({
                game_id: item.fillText![3].value,
                // isRelevance: item.fillText![4].checked,
              })
            : '',
      });
    }
    for (let item of this.textImage) {
      const IsAdvertising: boolean = item.position == '公告';
      selectValue = parseInt(item.fillText![3].value);

      if (IsAdvertising) {
        if (!item.imageUrl) {
          this.$message.error('公告位--' + item.position + '位置图片未上传');
          falg = false;
          return falg;
        } else if (!item.fillText![0].value) {
          this.$message.error('公告位--' + item.position + '标题未填写');
          falg = false;
          return falg;
        } else if (item.fillText![1].value == eOptionType.GAME) {
          if (selectValue <= 0) {
            this.$message.error('公告位--' + item.position + '游戏类型未选择');
            falg = false;
            return falg;
          }
        }

        this.paramsImages.advs.push({
          idx: 'idx_word',
          idx_name: '文字位',
          pos: item.positionValue,
          pos_name: item.position,
          img: item.imageUrl,
          main_title: item.fillText![0].value,
          sub_title: '', // 没有副标题
          link: item.fillText![2].value,
          op_type: item.fillText![1].value /* 类型 */,
          extend:
            item.fillText![1].value == 'game'
              ? JSON.stringify({
                  game_id: item.fillText![3].value,
                  // isRelevance: item.fillText![4].checked,
                })
              : '',
        });
        // console.log(this.paramsImages.advs);
      } else {
        selectValue = parseInt(item.fillText![4].value);
        if (!item.imageUrl && !item.fillText![0].value && !item.fillText![1].value && (!item.fillText![3].value || selectValue > 0)) {
          // 全部为空
          falg = true;
        } else {
          if (!item.imageUrl) {
            this.$message.error('文字位--' + item.position + '位置图片未上传');
            falg = false;
            return falg;
          } else if (!item.fillText![0].value) {
            this.$message.error('文字位--' + item.position + '位置标未填写');
            falg = false;
            return falg;
          } else if (!item.fillText![1].value) {
            this.$message.error('文字位--' + item.position + '副标题未填写');
            falg = false;
            return falg;
          } else if (item.fillText![2].value == eOptionType.GAME) {
            if (selectValue <= 0) {
              this.$message.error('文字位--' + item.position + '游戏类型未选择');
              falg = false;
              return falg;
            }
          }

          this.paramsImages.advs.push({
            idx: 'idx_word',
            idx_name: '文字位',
            pos: item.positionValue,
            pos_name: item.position,
            img: item.imageUrl,
            main_title: item.fillText![0].value,
            sub_title: item.fillText![1].value,
            link: item.fillText![3].value,
            op_type: item.fillText![2].value /* 类型 */,
            extend:
              item.fillText![2].value == 'game'
                ? JSON.stringify({
                    game_id: item.fillText![4].value,
                  })
                : '',
          });
        }
      }
    }
    //充值位
    const { state, popupState, desc, imageUrl, grade_id, grade_type } = this.rechargeModel;
    if (state) {
      // if (!desc) {
      //   this.$message.error('请输入充值角标!');
      //   falg = false;
      //   return falg;
      // }
      if (popupState) {
        if (!imageUrl) {
          this.$message.error('请选择充值弹出图片!');
          falg = false;
          return falg;
        }
      }
      //@Notice 和产品沟通, 不用判断选择了类型必须选档次, 如果选了类型,没选档次就相当于没有选绑定档次
      // if (grade_type !== -1 && grade_id === -1) {
      //   this.$message.error('请选择绑定的充值档位!');
      //   falg = false;
      //   return falg;
      // }
    }
    this.paramsImages.advs.push({
      idx: 'idx_charge',
      idx_name: '充值位',
      pos: '充值位',
      pos_name: '下',
      grade_type: grade_type,
      grade_id: grade_id,
      img: imageUrl,
      main_title: desc,
      sub_title: '',
      link: '',
      op_type: '' /* 类型 */,
      extend: '',
      disable: !state,
      default_show: popupState,
    });

    return falg;
  }
  async submitSave() {
    const falg = await this.rules();
    // console.log(this.paramsImages);

    if (falg && this.paramsImages && this.paramsImages.advs.length > 0) {
      this.$msgbox({
        title: '提示',
        message: '请仔细检查配置内容及跳转链接，确认生效后，将立即生效。',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            this.loading = true;
            await this.saveAd(this.paramsImages);
            done();
            instance.confirmButtonLoading = false;
            this.loading = false;
          } else if (action === 'cancel') {
            done();
          }
        },
      }).then(() => {
        // done();
      });
    }
  }
  async saveAd(params: iAdparams) {
    try {
      const res = await adAddEdit(params);
      if (res && res.code === 0) {
        //
        this.$message.success('保存成功');
      }
    } catch (err) {
      console.log(err);
    }
  }
  async getList() {
    try {
      const res = await getAdList({ app_id: 'cloudPC_client', idx: 'idx_img,idx_word,idx_charge' });
      if (res && res.code == 0) {
        //   console.log(res.data);

        for (let item of res.data) {
          if (item.idx === 'idx_img') {
            for (let key of item.advs) {
              const { link, main_title, img, extend, pos, op_type } = key;
              this.imagesList[pos].fillText![0].value = main_title;
              this.imagesList[pos].fillText![1].value = op_type;
              this.imagesList[pos].imageUrl = img;
              this.imagesList[pos].fillText![2].value = link;
              /* 得到扩展项目 */
              const extentItem: any = extend == '' ? '' : JSON.parse(extend);
              //   console.log(extentItem);
              if (extentItem) {
                this.imagesList[pos].fillText![3].value = extentItem.game_id; /* 扩展的游戏id */
                //  this.imagesList[pos].fillText![4].checked = extentItem.isRelevance; /* 是否免账号 */
              }
            }
          }
          if (item.idx === 'idx_word') {
            // console.log(item.advs);
            for (let key of item.advs) {
              const { link, main_title, sub_title, img, op_type, extend, pos, pos_name } = key;
              this.textImage[pos].fillText![0].value = main_title;
              this.textImage[pos].imageUrl = img;
              const IsAdvertising = pos_name === '公告'; /* 是否是广告 */
              if (IsAdvertising) {
                this.textImage[pos].fillText![1].value = op_type;
                this.textImage[pos].fillText![2].value = link;
              } else {
                this.textImage[pos].fillText![1].value = sub_title;
                this.textImage[pos].fillText![2].value = op_type;
                this.textImage[pos].fillText![3].value = link;
              }
              /* 得到扩展项目 */
              const extentItem: any = extend == '' ? '' : JSON.parse(extend);
              if (extentItem) {
                const { game_id } = extentItem;
                let num = 3;
                if (!IsAdvertising) {
                  num = 4;
                }
                this.textImage[pos].fillText![num].value = game_id; /* 扩展的游戏id */
                //  this.textImage[pos].fillText![num + 1].checked = isRelevance; /* 是否免账号 */
              }
            }
          }

          if (item.idx === 'idx_charge') {
            let newLength = item.advs.length;
            if (newLength > 0) {
              const { img, main_title, disable, default_show, grade_id, grade_type } = item.advs[0];
              this.rechargeModel.desc = main_title;
              this.rechargeModel.imageUrl = img;
              this.rechargeModel.state = !disable;
              this.rechargeModel.popupState = default_show;
              this.rechargeModel.grade_id = grade_id;
              this.rechargeModel.grade_type = grade_type;
            }
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }
  /* 游戏类别 */
  async getGameList(key: string = '') {
    const res: any = await this.publicQuery.getGameList(key);
    if (res) {
      this.gameList = res;
    }
  }
  async setValue() {
    await this.getGameList();
    this.imagesList = [
      {
        id: '',
        position: '左一',
        positionValue: '0', // 位置值
        imageUrl: '',
        uploadText: '添加图片',
        isClass: true,
        uploadSizeType: '520*211 png,jpg',
        // eslint-disable-next-line no-dupe-keys
        extend: this.extend,
        fillText: [
          { title: '标题', value: '', placeholder: '请输入标题，不超过48个字', max: 48 },
          {
            title: '类型',
            value: 'game',
            placeholder: '',
            type: eInputType.RADIO,
            childrens: this.openTypeList,
          },
          { title: '', value: '', placeholder: '请输入跳转连接', type: eInputType.INPUT },
          {
            title: '',
            value: -1,
            placeholder: '',
            type: eInputType.SELECT,
            isRelevance: true,
            childrens: this.gameList,
            filterable: true,
          },
        ],
      },
      {
        id: '',
        position: '中间',
        positionValue: '1',
        imageUrl: '',
        uploadText: '添加图片',
        isClass: true,
        uploadSizeType: '520*211 png,jpg',
        extend: this.extend,
        fillText: [
          { title: '标题', value: '', placeholder: '请输入标题，不超过48个字', max: 48 },
          {
            title: '类型',
            value: 'game',
            placeholder: '',
            type: eInputType.RADIO,
            childrens: this.openTypeList,
          },
          { title: '', value: '', placeholder: '请输入跳转连接', type: eInputType.INPUT },

          {
            title: '',
            value: -1,
            placeholder: '请输入关键字搜索',
            type: eInputType.SELECT,
            isRelevance: true,
            childrens: this.gameList,
            filterable: true,
          },
        ],
      },
      {
        id: '',
        position: '右一',
        positionValue: '2',
        imageUrl: '',
        uploadText: '添加图片',
        uploadSizeType: '520*211 png,jpg',
        extend: this.extend,
        fillText: [
          { title: '标题', value: '', placeholder: '请输入标题，不超过48个字', max: 48 },
          {
            title: '类型',
            value: 'game',
            placeholder: '',
            type: eInputType.RADIO,
            childrens: this.openTypeList,
          },
          { title: '', value: '', placeholder: '请输入跳转连接', type: eInputType.INPUT },
          {
            title: '',
            value: -1,
            placeholder: '请输入关键字搜索',
            type: eInputType.SELECT,
            isRelevance: true,
            childrens: this.gameList,
            filterable: true,
          },
        ],
      },
    ];
    this.textImage = [
      {
        id: '',
        position: '上一',
        positionValue: '0',
        imageUrl: '',
        uploadText: '添加图片',
        isClass: true,
        uploadSizeType: '76*70 png,jpg',
        extend: this.extend,
        fillText: [
          { title: '标题', value: '', placeholder: '请输入标题，不超过64个字', max: 64 },
          { title: '副标题', value: '', placeholder: '请输入副标题，不超过80个字', max: 80 },
          {
            title: '类型',
            value: 'game',
            placeholder: '',
            type: eInputType.RADIO,
            childrens: this.openTypeList,
          },
          { title: '', value: '', placeholder: '请输入跳转连接', type: eInputType.INPUT },
          {
            title: '',
            value: -1,
            placeholder: '请输入关键字搜索',
            type: eInputType.SELECT,
            isRelevance: true,
            childrens: this.gameList,
            filterable: true,
          },
        ],
      },
      {
        id: '',
        position: '中间',
        positionValue: '1',
        imageUrl: '',
        isClass: true,
        uploadSizeType: '76*70 png,jpg',
        uploadText: '添加图片',
        extend: this.extend,
        fillText: [
          { title: '标题', value: '', placeholder: '请输入标题，不超过64个字', max: 64 },
          { title: '副标题', value: '', placeholder: '请输入副标题，不超过80个字', max: 80 },
          {
            title: '类型',
            value: 'game',
            placeholder: '',
            type: eInputType.RADIO,
            childrens: [
              {
                label: '跳转链接',
                value: 'link',
              },
              {
                label: '打开游戏',
                value: 'game',
              },
            ],
          },
          { title: '', value: '', placeholder: '请输入跳转连接', type: eInputType.INPUT },
          {
            title: '',
            value: -1,
            placeholder: '请输入关键字搜索',
            type: eInputType.SELECT,
            isRelevance: true,
            childrens: this.gameList,
            filterable: true,
          },
        ],
      },
      {
        id: '',
        position: '公告',
        positionValue: '2',
        imageUrl: '',
        uploadText: '添加图片',
        uploadSizeType: '76*70 png,jpg',
        extend: this.extend,
        fillText: [
          { title: '标题', value: '', placeholder: '请输入标题，不超过168个字', max: 168 },
          {
            title: '类型',
            value: 'game',
            placeholder: '',
            type: eInputType.RADIO,
            childrens: this.openTypeList,
          },
          { title: '', value: '', placeholder: '请输入跳转连接', type: eInputType.INPUT },
          {
            title: '',
            value: -1,
            placeholder: '请输入关键字搜索',
            type: eInputType.SELECT,
            isRelevance: true,
            childrens: this.gameList,
            filterable: true,
          },
        ],
      },
    ];
    this.getList();
  }
  mounted() {
    this.setValue();
  }
}
